module.exports = new __parcel__URL__("sit.649e685d.png").toString();